
export default function accordion() {

        const $accordionButton = $('.accordion__button');
        
        $accordionButton.click(function() {
          if ($(this).hasClass('is-active')) {
            $(this).next().slideToggle(280);
            $(this).next().attr("aria-expanded","false");
            $(this).removeClass('is-active');
          } else { 
            $(this).next().slideToggle(280);
            $(this).next().attr("aria-expanded","true");
            $(this).addClass('is-active');
            console.log('hitting accordion');
          } 
        });
      }